import mapStyles from './mapStyles';
const moment = require('moment');

const LocationMap = () => {

    let postLocations = null;
    let mapContainer = null;

    let init = ( item ) => {


        // let data = sessionStorage.getItem('postLocations');
        let data = null;

        if ( data ) {

            postLocations = JSON.parse(data);
            renderMap();

        } else {

            var xhr = new XMLHttpRequest();
            xhr.open('GET', 'api/v1/postLocations');
            xhr.send(null);

            xhr.onreadystatechange = function () {
              
                var DONE = 4; // readyState 4 means the request is done.
                var OK = 200; // status 200 is a successful return.

                if (xhr.readyState === DONE) {
                    if (xhr.status === OK) {

                        postLocations = JSON.parse(xhr.responseText);
                        sessionStorage.setItem('postLocations', xhr.responseText);
                        renderMap();

                    } else {
                        console.log('Error: ' + xhr.status);
                    }
                }
            }
        }
    }


    let renderMap = () => {

        let item = postLocations.data.slice(-1).pop(),
            container = mapContainer,
            position = {
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lng),
            },
            zoom = 15;

        let map = new google.maps.Map(container, {
            center: position,
            zoom: zoom,
            styles: mapStyles,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true
        });

        let infowindow = new google.maps.InfoWindow(),
            bounds = new google.maps.LatLngBounds(),
            markers = [],
            icon = {
                path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
                fillColor: '#000000',
                fillOpacity: 0.3,
                anchor: new google.maps.Point(0,0),
                strokeWeight: 0,
                scale: 0.4
            };
        
        postLocations.data.map((item, index) => {

            // If last item
            if ( postLocations.data.length-1 === index ) {
                icon.fillColor = '#FF0000';
                icon.fillOpacity = 0.6;
                icon.scale = 0.6;
            }

            let marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.lng),
                },
                map: map,
                //label: `${index+1}`,
                title: item.title,
                icon: icon
            });
            markers.push(marker);

            marker.addListener('click', function() {

                let c = '<div class="info-window-content">';
                if ( item.thumb ) {
                    c += '<div class="image">';
                    c += `<img src="${item.thumb.url}" alt="${item.thumb.title}">`;
                    c += '</div>';
                }
                
                c += '<div class="inner-content">';
                c += `<h3><a href="${item.url}">${item.title}</a></h3>`;
                c += `<span>Publisert: ${moment(item.postDate.date).format('DD.MM YYYY')}</span>`;
                c += '</div>';
                c += '</div>';

                infowindow.setContent(c);
                infowindow.open(map, marker);
            });

            bounds.extend(marker.getPosition());

        })

        // https://developers.google.com/maps/documentation/javascript/marker-clustering
        // var markerCluster = new MarkerClusterer(map, markers, {imagePath: '/assets/map/m'});

        map.fitBounds(bounds);

        

    }

    window.initLocationMap = () => {
        mapContainer = document.getElementById('location-map-container');
        if (mapContainer) {
            init();
        }
        return;
    }


}

export default LocationMap;


// WEBPACK FOOTER //
// ./src/js/initLocationMap.js